var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('color: ' + _vm.getColor(_vm.type, _vm.status))},[_vm._v(_vm._s(_vm.getText(_vm.type, _vm.status)))])}
var staticRenderFns = []

export { render, staticRenderFns }